import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import sortBy from 'lodash/sortBy';
import { addressDataHelper } from 'components/common/helpers/addressDataHelper';
import classNames from 'classnames';
import TransHelper from 'components/common/translations/TransHelper';

function addClassFavLast() {
  var items = document.getElementsByClassName('list-autocomplete__item--fav');
  var elemsFav = document.querySelectorAll('.list-autocomplete__item--fav');

  for (var i = 0; i < elemsFav.length; i++) {
    elemsFav[i].classList.remove('list-autocomplete__item--fav-last');
  }

  if (items.length) {
    items[items.length - 1].classList.add('list-autocomplete__item--fav-last');
  }
}

class AutocompleteItems extends React.Component {

  componentDidMount = () => {
    addClassFavLast();
  }

  componentDidUpdate = () => {
    addClassFavLast();
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  getItems = () => {
    var results = [];
    const { options } = this.props;
    var sortedOptions = sortBy(options, ['fav', 'g', 'label']);
    for (var i = 0; i < sortedOptions.length; i++) {
      var opt = sortedOptions[i];
      results.push(
        <Item
          key={i}
          options={opt}
          handleClickItem={this.handleClickItem}
        />
      );
    }
    return results;
  }

  renderItems = () => {
    var items = this.getItems();
    if (items.length) {
      return items;
    }

    return (
      <li className="list-autocomplete__item list-autocomplete__item--empty">
        <FontAwesomeIcon
          icon={['far', 'frown']}
        />
        <em>{this.trans('content.notifications.addressComponent.noResults')}</em>
      </li>
    )
  }

  handleClickItem = (e, option) => {
    if (this.props.handleChange) {
      this.props.handleChange(option);
    }
  }

  getVisibleProperty = () => {
    if (this.props.show) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    return (
      <div style={{ display: this.getVisibleProperty() }} className="list-autocomplete-wrap" >
        <ul className="list-autocomplete">
          {this.renderItems()}
        </ul>
      </div>
    );
  }
}

export default AutocompleteItems;

class Item extends React.Component {

  getIconName = () => {
    const { icon } = addressDataHelper(this.props.options.type)
    return icon;
  }

  handleClickItem = (e) => {
    this.props.handleClickItem(e, this.props.options);
  }

  render() {
    const { options } = this.props;
    var isOnlyStreet = options.fav != true && options.g;
    var isOnlyBusStop = options.fav != true && options.g != true;
    var isFavoritePlaces = options.fav;

    return (
      <li
        onClick={this.handleClickItem}
        className={classNames(
          'list-autocomplete__item', {
            'list-autocomplete__item--fav': isFavoritePlaces,
            'list-autocomplete__item--bus': isOnlyBusStop,
            'list-autocomplete__item--street': isOnlyStreet
          },
        )}
      >
        {isFavoritePlaces &&
          <FontAwesomeIcon
            icon={['fas', this.getIconName()]}
          />
        }
        {isOnlyBusStop &&
          <FontAwesomeIcon
            icon={['fas', 'bus']}
          />
        }
        {isOnlyStreet &&
          <FontAwesomeIcon
            icon={['fas', 'map-marker-alt']}
          />
        }
        {options.label}
      </li>
    );
  }
}
